import NewColors from "./NewColors";
import { createTheme } from "@mui/material";

const mainTheme = createTheme({
  palette: {
    primary: {
      main: NewColors.active.primary,
    },
    secondary: {
      main: NewColors.active.secondary,
    },
    primaryTransparent: {
      main: NewColors.status.error, // Use semantic error color
    },
    editButton: {
      main: NewColors.text.primary, // Use semantic text color instead of hardcoded black
    },
    // Add semantic color palette to MUI theme using active theme
    brand: {
      main: NewColors.active.primary,
      light: NewColors.nutrition.caloriesBackground, // Light background for brand
      dark: NewColors.active.primaryButtonHover,
    },
    link: {
      main: NewColors.active.primary,
      dark: NewColors.active.primaryButtonHover,
    },
  },
  typography: {
    fontFamily: ["Lato"].join(","),
    h3: {
      color: NewColors.active.primary,
      fontSize: 30,
      fontWeight: "bold",
    },
    h4: {
      fontSize: 25,
      fontWeight: "bold",
    },
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiMenu: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiPopover: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiModal: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiDialogTitle: {
      defaultProps: {
        textAlign: "left",
        fontSize: 30,
        fontWeight: "bold",
      },
    },
    MuiList: {
      defaultProps: {
        padding_top: 0,
      },
    },
  },
  overrides: {
    MuiList: {
      padding: {
        paddingTop: 0,
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: 10,
      },
    },
    MuiTableCell: {
      root: {
        padding: 6,
        fontSize: 14,
      },
      body: {
        padding: 6,
      },
    },
    MuiButton: {
      label: {
        textTransform: "none",
      },
    },
    MuiDialogActions: {
      root: {
        marginTop: 20,
        marginBottom: 20,
        marginRight: 20,
      },
    },
    MuiDialogTitle: {
      root: {
        "& h2": {
          textAlign: "left",
          fontSize: 30,
          fontWeight: "bold",
        },
      },
    },
    MuiTypography: {
      root: {
        "& a:-webkit-any-link": {
          color: NewColors.active.primary,
        },
      },
    },
  },
});

export default mainTheme;
